// A message a rider can read from a failed API call. Validation failures come back
// as { error: 'Validation failed', details: [{ message }] }; rate limits as 429.
export function apiErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const status = err?.response?.status;
  const data = err?.response?.data;
  if (status === 429) return 'Too many attempts. Please try again later.';
  if (Array.isArray(data?.details) && data.details[0]?.message) return data.details[0].message;
  if (typeof data?.error === 'string' && data.error !== 'Validation failed') return data.error;
  if (!err?.response) return 'We couldn’t reach RoolDrive. Please check your connection and try again.';
  return fallback;
}
